export default function ($translate) {
    return {
        KEYS: {
            SAME_FOR_ALL: 'SAME_FOR_ALL',
            INDIVIDUAL: 'INDIVIDUAL',
            FROM_CSV: 'FROM_CSV'
        },
        LABELS: {
            NOT_STARTED: $translate.instant('historic.occurrence.Same for all'),
            IN_PROGRESS: $translate.instant('historic.occurrence.Individual')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/course/historicOccurrence/completionType/index.js